module.exports = __webpack_public_path__ + "media/src/assets/messages_frenchie-260273db720c6a32ce7610b7fa5a963c.svg";